/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum QueueStatus {
  Stored = 1,
  Extracting = 2,
  FailedExtract = 3,
  Ready = 4,
  Failed = 5,
  WatingForConfirm = 8,
  Rejected = 10,
  Updating = 11,
  BeforeAddJob = 12,
  TwentyFivePercentOfExtractingIsDone = 13,
  FiftyPercentOfExtractingIsDone = 14,
  SeventyFivePercentOfExtractingIsDone = 15,
  WaitingUserConfirmation = 16,
  Calculating = 17,
  CreatingNextScheduledMessage = 18,
  CheckSendLimit = 19,
  CheckWhiteMessage = 20,
  Extracted = 21
}
